import React, { FC } from 'react'
import { SignUpEmail } from './SignUpEmail'

export const ForgetPasswordEmail: FC = () => {
    return <SignUpEmail isForgetPassword={true} />
}
